export class EditableWorkReportRequest {
  projectId?: number;
  sectionId?: number;
  sectionItemId?: number;
  formId?: number;
  formCode?: string;
  formCopiesOrder?: number;
}
